import moment from "moment";

export const DATE_TIME_PICKER_MODEL = {
    DATE_TIME: 'DATE_TIME',
    DATE: 'DATE',
    TIME: 'TIME',
    RANGE: 'RANGE'
}

export const calculateRange = (startDate, rangeLength, rangeUnit) => {
    return moment(startDate)
        .add(rangeLength, rangeUnit)
        .subtract(1, 'millisecond')
        .toDate();
};
